import React from 'react';
import styled from 'astroturf/react';
import { BodyLink } from 'js/design_system/link/BodyLink';
import _ProfileIcon from "Avatar-ProfileIcon.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Avatar.tsx?styleId=ProfileIcon";
import _Link from "Avatar-Link.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Avatar.tsx?styleId=Link";
import _Name from "Avatar-Name.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/Avatar.tsx?styleId=Name";


const ProfileIcon = /*#__PURE__*/styled("img", null, {
  displayName: "ProfileIcon",
  styles: _ProfileIcon
});

const Link = /*#__PURE__*/styled("a", null, {
  displayName: "Link",
  styles: _Link
});

export const Name = /*#__PURE__*/styled(BodyLink, null, {
  displayName: "Name",
  styles: _Name
});

const DEFAULT_PHOTO_URL = '/images/s65_no_pic.png';

type Props = {
  /**
   * This is used for the link's `aria-label`,
   * since the only content is an image.
   */
  fullName: string;
  /**
   * Determines whether the avatar should render with
   * a wrapping `a` tag or a wrapping `div`.
   * This is useful if you want to use this component inside
   * of a link, since `a` tags cannot contain other `a` tags.
   */
  profileUrl?: string;
  photoUrl: string;
  small?: boolean;
  style?: React.CSSProperties;
  className?: string;
};

export default function Avatar({
  fullName,
  photoUrl,
  profileUrl,
  small = false,
  style,
  className,
}: Props) {
  const conditionalHref: { href?: string } = {};
  if (profileUrl != null) {
    conditionalHref.href = profileUrl;
  }

  return (
    <Link
      aria-label={`${fullName}'s profile`}
      as={profileUrl != null ? 'a' : 'div'}
      small={small}
      className={className}
      style={style}
      {...conditionalHref}
    >
      <ProfileIcon
        className={'clickable'}
        alt=""
        src={photoUrl}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null;
          currentTarget.src = DEFAULT_PHOTO_URL;
        }}
      />
    </Link>
  );
}
